import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Typography, tabsClasses, useMediaQuery, Box } from "@mui/material";
import Tab from "@mui/material/Tab";
import { styled } from "@mui/material/styles";
import * as React from "react";
import { VehicleConditionRightView } from "./vehicleStructure";
import { useEffect } from "react";
var CustomTabList = styled(TabList)({
    borderRadius: "none",
    border: "none",
    display: 'flex',
    alignItems: 'center'
});
var CustomTab = styled(Tab)({
    textTransform: "capitalize",
    fontWeight: 600,
    fontSize: "14px",
    padding: "0px",
    minHeight: "30px",
    borderRadius: "8px",
    margin: "2px",
    color: "#8593A3",
    "& .css-heg063-MuiTabs-flexContainer": {
        background: "blue"
    },
    border: "1px solid transparent",
    "&.Mui-selected": {
        color: "#000",
        backgroundColor: "#fff",
        border: '1px solid #ddd'
    }
});
export var ImageViewCustomTabs = function (props) {
    var _a;
    var _items$0$ProductCondi, _items$;
    var items = props.items, variant = props.variant, handleConditionChange = props.handleConditionChange, handleRemoveCondition = props.handleRemoveCondition, isDisabled = props.isDisabled;
    var _b = React.useState((_items$0$ProductCondi = (_items$ = items[0]) === null || _items$ === void 0 ? void 0 : _items$.ProductConditionViewId) !== null && _items$0$ProductCondi !== void 0 ? _items$0$ProductCondi : ""), value = _b[0], setValue = _b[1];
    var _c = React.useState(), list = _c[0], setList = _c[1];
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    useEffect(function () {
        if (items && items.length > 0) {
            setList(items);
            if (!value) {
                setValue(items[0].ProductConditionViewId);
            }
        }
    }, [items]);
    var handleChange = function (event, newValue) {
        setValue(newValue);
    };
    return /*#__PURE__*/ React.createElement(TabContext, {
        value: value
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            backgroundColor: "#EFF2F5",
            justifyContent: "center",
            display: 'flex',
            borderRadius: "8px",
            border: "1px solid #DEE4EB",
            width: '100%'
        }
    }, /*#__PURE__*/ React.createElement(CustomTabList, {
        sx: (_a = {
                minHeight: "26px",
                "& .MuiTabs-indicator": {
                    display: "none"
                }
            },
            _a["& .".concat(tabsClasses.scrollButtons)] = {
                '&.Mui-disabled': {
                    opacity: 0.3
                }
            },
            _a.padding = '1px',
            _a.justifyContent = 'space-between',
            _a.width = '100%',
            _a.paddingX = {
                sm: 1
            },
            _a),
        variant: "scrollable",
        orientation: "horizontal",
        scrollButtons: "auto",
        allowScrollButtonsMobile: true,
        onChange: handleChange
    }, list === null || list === void 0 ? void 0 : list.map(function (item, index) { /*#__PURE__*/ return React.createElement(CustomTab, {
        sx: {
            // marginRight: "5px", 
            color: 'text.secondary',
            "&.Mui-selected": {
                bgcolor: 'white'
            },
            paddingX: 2,
            height: 40,
            width: '33%'
        },
        key: index,
        label: /*#__PURE__*/ React.createElement(Typography, {
            fontSize: 'base',
            fontWeight: 'strong',
            color: value === (item === null || item === void 0 ? void 0 : item.ProductConditionViewId) ? '#1B1D21' : '#6A7682',
            variant: "caption",
            align: "center"
        }, item === null || item === void 0 ? void 0 : item.Name),
        value: item === null || item === void 0 ? void 0 : item.ProductConditionViewId
    }); }))), list === null || list === void 0 ? void 0 : list.map(function (item, index) { /*#__PURE__*/ return React.createElement(TabPanel, {
        sx: {
            padding: "10px"
        },
        key: index,
        value: item.ProductConditionViewId,
        style: {
            overflowY: "scroll",
            minHeight: "450px"
        }
    }, /*#__PURE__*/ React.createElement(VehicleConditionRightView, {
        precheckList: item.checkListItems,
        imageAttachment: item.ImageAttachment,
        onChange: handleConditionChange,
        onRemove: handleRemoveCondition,
        isDisabled: isDisabled
    })); }));
};
